import { AddToWishlistService } from './AddToWishlistService.js';
import { ToggleBox } from '../toggles/toggleBox.js';
import { AdjustTracking } from './AdjustTracking.js';
import { FirebaseTracking } from './FirebaseTracking.js';
import { eventQBus } from '@otto-ec/global-resources/event-q-bus';
import { NexusApi } from './NexusApi';

window.o_wishlistApi = window.o_wishlistApi || {};

if (!window.o_wishlistApi.initialized) {
    const toggles = new ToggleBox(document.querySelector('.wl_toggleInfo'));
    const adjustTracking = new AdjustTracking();
    const firebaseTracking = new FirebaseTracking();
    new AddToWishlistService(adjustTracking, firebaseTracking, toggles).init();
    eventQBus.emitModuleInitialized('ft1.wishlist-view.addToWishlistService');
    const nexusApi = new NexusApi(new AdjustTracking(), new FirebaseTracking());
    nexusApi.init();
    window.o_wishlistApi.initialized = true;
}
